import { Component, OnInit, ViewChild } from '@angular/core';
import { CompareGroupService } from '../comparegroupservice.service';
import { OrganizationDetailDTO } from '../organzation-detail.dto';
//import { MatTableDataSource, MatSort, MatPaginator, MatListOption } from '@angular/material';
import { MatPaginator } from '@angular/material/paginator';
import { MatListOption } from '@angular/material/list';
import { MatTableDataSource } from '@angular/material/table';
import { MatSort } from '@angular/material/sort';
import { ActivatedRoute, Router } from '@angular/router';
import { CompareGroupMemberDTO, CompareGroupMemberListDTO } from '../compare-group-member.dto';
import { Logger } from '../../shared/logger/logger.component';
import { DisplayedColumn } from '../displayed-column';
import { CustomOktaAuthService } from '../../auth/oktaauth.service';
import { Subscription } from 'rxjs';
import { OrganizationDTO } from '../organization.dto';

@Component({
    selector: 'app-comparegroupdetail',
    templateUrl: './comparegroupdetail.component.html',
    styleUrls: ['./comparegroupdetail.component.scss'],
    standalone: false
})
export class CompareGroupDetailComponent implements OnInit {

  compareGroupDescription: string;

  isLoading = true;
  isListEmpty = true;
  isDirty = false;
  compareGroupId: number;
  organizationId: number;
  allSelected: boolean;
  noNameGiven = false;

  isEditing = false;
  showColumnList = false;
  showSelected = false;

  lastFilter: string;

  organizationList: OrganizationDetailDTO[] = [];
  compareGroupMemberList: CompareGroupMemberDTO[] = [];
  selectedOrgSubscription: Subscription;
  selectedOrg: OrganizationDTO;

  displayedColumns: DisplayedColumn[] = [
    // commented columns are AHA data to be hidden until data can be finalized
    { def: 'compareGroupMember', label: 'Selected Members', show: true },
    { def: 'orgName', label: 'Organization Name', show: true },
    { def: 'region', label: 'State', show: true },
    { def: 'numberOfCohortPerYear', label: 'Number of Cohorts per Year', show: true },
    // { def: 'hospitalSize', label: 'Hospital Size', show: true },
    { def: 'magnetRecognition', label: 'Magnet Recognition', show: true },
    { def: 'pathwayToExcellence', label: 'Pathway To Excellence', show: true },
    { def: 'accreditation', label: 'Accredited', show: true },
    { def: 'parentSystems', label: 'System Name(s)', show: true },
    // { def: 'teachingStatus', label: 'Teaching Status', show: false },
    // { def: 'medicalSchoolAffiliationReportedToAMA',
    //        label: 'Medical School Affiliation Reported to American Medical Association', show: false },
    // { def: 'hospitalLocation', label: 'Hospital Location', show: false },
    // { def: 'criticalAccessHospital', label: 'Critical Access Hospital', show: false },
    // { def: 'primaryService', label: 'Primary Service', show: false },
    { def: 'unionized', label: 'Unionized', show: false },
    { def: 'bedsTotalFacility', label: 'Active Beds', show: false },
    { def: 'numberOfFTEs', label: 'FTE Allocated to NRP', show: false },
    { def: 'ratioOfFacilitatorPerResident', label: 'Ratio of Facilitators per Resident', show: false },
    { def: 'durationOfSeminar', label: 'Duration of Seminar', show: false },
    { def: 'programDelivery', label: 'Program Delivery', show: false },
    { def: 'clinicalReflection', label: 'Clinical Reflection', show: false },
    { def: 'periodDate', label: 'Date of Last Annual Site Survey Update', show: false },
    // { def: 'rnDirectPatientCareFTE', label: 'RN Direct Patient Care (FTE)', show: false },
    // { def: 'totalBirthsExcludingFetalDeaths', label: 'Total Births (Excluding Fetal Deaths)', show: false },
    // { def: 'totalOutpatientVisits', label: 'Total Outpatient Visits', show: false },
    // { def: 'averageDailyCensus', label: 'Average Daily Census', show: false },
    { def: 'activationDate', label: 'Date organization joined NRP', show: false },
    { def: 'numberOfNewRNGraduatesHired', label: 'Total New Graduate Nurses Hired per Year', show: false },
    { def: 'orgClassificationType', label: 'Organization Type', show: false}

    // { def: 'frequencyOfSeminars', label: 'Frequency of Seminars', show: true },
  ];

  displayedColumnsDescription: string[] = [
    'compareGroupMember-description'
  ];

  updateColumnSelection: string[] = [];

  paginationLength = 100;
  paginationSize = 10;
  paginationSizeOptions: number[] = [5, 10, 25, 50, 100];

  showAlert = false;
  alertIsConfirm = false;
  alertMessage = '';

  columnStorageString: string;

  dataSource: MatTableDataSource<OrganizationDetailDTO> = new MatTableDataSource([]);

  @ViewChild(MatSort, {static: true}) sort: MatSort;
  @ViewChild(MatPaginator, {static: true}) paginator: MatPaginator;

  constructor(
    private compareGroupService: CompareGroupService,
    private activatedRoute: ActivatedRoute,
    private router: Router,
    private logger: Logger,
    private oktaService: CustomOktaAuthService
  ) { }

  ngOnInit() {
    this.oktaService.refreshToken('compare group detail init');
    this.activatedRoute.params.subscribe(params => {
      let invalid = false;
      let message = '';

      if (params.orgId === undefined || isNaN(params.orgId)) {
        invalid = true;
        message = 'Invalid organization id.';
      } else {
        this.organizationId = parseInt(params.orgId, 10);
        this.setSelectedOrg(this.organizationId);
      }

      if (params.groupId !== undefined) {
        if (isNaN(params.groupId) || params.groupId < 0) {
          invalid = true;
          message = 'Invalid group id.';
        }

        this.compareGroupId = parseInt(params.groupId, 10);
        this.isEditing = true;

      } else {
        this.compareGroupId = 0;
        this.isEditing = false;
      }

      if (invalid) {
        this.logger.log(message);
        this.router.navigate(['/comparegroups']);
      }

      let userId;

      try {
        const userData = JSON.parse(sessionStorage.getItem('okta-token-storage'));
        userId = userData.idToken.claims.user_guid;
      } catch {
        console.error('Invalid user data');
        userId = 'local';
      }

      this.columnStorageString = 'savedColumns:' + userId;

      const savedColumns = localStorage.getItem(this.columnStorageString);

      if (savedColumns != null) {
        this.updateColumnSelection = savedColumns.split(',');
        this.updateShownColumns(false);
      } else {
        this.updateColumnSelection = this.getDisplayedColumns();
      }

      this.getCompareGroupDetail();
    });
  }

  setSelectedOrg(orgID: number) {
    this.selectedOrgSubscription = this.compareGroupService.getOrgIDs()
      .subscribe((response) => {
        this.selectedOrg = response.find(x => x.orgId === orgID);
      });
  }

  getCompareGroupDetail() {
    this.isLoading = true;
    const orgListSubscription =
      this.compareGroupService.getOrgList()
        .subscribe((result) => {
          this.organizationList = result;

          if (this.compareGroupId > 0) {
            const compareGroupMemberSubscription =
              this.compareGroupService.getCompareGroupMembers(this.compareGroupId)
                .subscribe((members) => {
                  this.compareGroupMemberList = members;

                  this.compareGroupMemberList.forEach(member => {

                    if (!this.compareGroupDescription) {
                      this.compareGroupDescription = member.compareGroupDesc;
                    }

                    const groupId = member.compareGroupId;
                    const memberId = member.memberOrgId;

                    if (groupId === this.compareGroupId) {
                      this.organizationList.forEach(l => {
                        if (memberId === l.orgID) {
                          l.compareGroupMember = true;
                        }
                      });
                    }
                  });

                  compareGroupMemberSubscription.unsubscribe();
                }
            );
            this.isLoading = false;
          } else {
            this.isLoading = false;
          }

          if (this.organizationList != null) {
            this.isListEmpty = this.organizationList.length === 0;
          }

          this.dataSource = new MatTableDataSource(this.organizationList);

          this.sortOrganizationList();

          this.dataSource.paginator = this.paginator;
          this.dataSource.sort = this.sort;

          this.dataSource.sortingDataAccessor = (item, property): string | number => {
            switch (property) {
              case 'periodDate': return new Date(item.periodDate).getFullYear();
              case 'activationDate': return new Date(item.activationDate).getFullYear();
              default: return item[property];
            }
          };

          orgListSubscription.unsubscribe();
        }
    );
  }

  sortOrganizationList() {
    this.dataSource.data.sort(
      (a, b) => {
        const nameA = a.orgName.toLowerCase();
        const nameB = b.orgName.toLowerCase();
        if (nameA < nameB) { return -1; }
        if (nameA > nameB) { return  1; }
        return 0;
      }
    );
  }

  getDisplayedColumns() {
    return this.displayedColumns.filter(dc => dc.show).map(dc => dc.def);
  }

  getDisplayedColumnsDescription() {
    return this.displayedColumnsDescription;
  }

  getSelectedMembers() {
    return this.dataSource.filteredData.filter(ds => ds.compareGroupMember);
  }

  removeUnselected(toKeep: MatListOption[]) {

    this.dataSource.filteredData.forEach(
      d => {
        d.compareGroupMember = false;
      }
    );

    this.dataSource.filteredData.forEach(
      d => {
        toKeep.forEach(r => {
          if (d.orgID.toString() === r.value) {
            d.compareGroupMember = true;
          }
        });
      }
    );

    this.updateGroupMembers();
  }

  onSelectAll(event) {
    event.stopPropagation();

    this.allSelected = !this.allSelected;

    this.organizationList.forEach(c => {
      c.compareGroupMember = this.allSelected;
    });

    this.updateGroupMembers();
  }

  onSetColumn(column) {

    const index = this.updateColumnSelection.indexOf(column);

    if (index > -1) {
      delete(this.updateColumnSelection[index]);
    } else {
      this.updateColumnSelection.push(column);
    }

    // Remove empty elements
    this.updateColumnSelection = this.updateColumnSelection.filter(c => c != null);

    localStorage.setItem(this.columnStorageString, this.updateColumnSelection.join(','));
  }

  updateShownColumns(toggle = true) {

    this.displayedColumns.forEach(dc => {
      dc.show = false;
    });

    this.updateColumnSelection.forEach(uc => {
      this.displayedColumns.forEach(dc => {
        if (uc === dc.def) {
          dc.show = true;
        }
      });
    });

    if (toggle) {
      this.showColumnList = !this.showColumnList;
    }

    this.applyFilter(this.lastFilter);
  }

  updateGroupMembers() {
    this.compareGroupMemberList = [] as CompareGroupMemberDTO[];
    this.organizationList.forEach(o => {
      if (o.compareGroupMember) {

        const newMember = {} as CompareGroupMemberDTO;
        newMember.compareGroupId = this.compareGroupId;
        newMember.memberOrgId = o.orgID;

        this.compareGroupMemberList.push(newMember);
      }
    });

    this.isDirty = true;
  }

  applyFilter(filterValue: string) {

    this.lastFilter = filterValue;

    this.dataSource.filterPredicate = (dto: OrganizationDetailDTO, filter: string) => {

      let found = false;
      this.displayedColumns.forEach(
        ds => {

          if (ds.show === true) {
            const name = ds.def;

            let dtoValue = dto[name];
            let valid = true;

            switch (typeof(dtoValue)) {
              case 'string':
                  break;
              case 'number':
                  dtoValue = dtoValue.toString();
                  break;
              case 'object':
                  dtoValue = dtoValue ? JSON.stringify(dtoValue) : '';
                  break;
              default:
                  valid = false;
                  break;
            }

            if (valid) {
              found = found || dtoValue.trim().toLowerCase().indexOf(filter.trim().toLowerCase()) >= 0;
            }
          }
        }
      );

      return found;
    };

    this.dataSource.filter = filterValue;
  }

  validateGroupSystems(){
    
    const currentSystem = JSON.stringify(this.selectedOrg.parentHCOIDs);
    //gets selected members -> selects just the hcoids -> filters for unique values
    let memberSystems = this.organizationList.filter(ds => ds.compareGroupMember).map(dc => JSON.stringify(dc.parentHCOIDs)).filter((itm, idx, arr) => arr.indexOf(itm) === idx);
    if (currentSystem){
      memberSystems = memberSystems.filter(x => x != currentSystem);
    }
      
    return (memberSystems.length > 1 || (memberSystems.length == 1 && memberSystems[0] == 'null'));
  }

  onSave(newGroup: boolean) {

    if (this.compareGroupDescription === undefined || this.compareGroupDescription === '') {
      this.showAlert = true;
      this.alertIsConfirm = false;
      this.alertMessage = 'Please name this benchmark.';
      return;
    }

    const saveList = this.createCompareGroupSaveList(newGroup);
    if (saveList.compareGroupMembers.length < 5) {
      this.showAlert = true;
      this.alertIsConfirm = false;
      this.alertMessage = 'At least 5 organizations must be selected.';
      return;
    }

    // validates that compare group has more than one system other than it's own
    // if (!this.validateGroupSystems()) {
    //   this.showAlert = true;
    //   this.alertIsConfirm = false;
    //   this.alertMessage = 'At least 5 organizations from two different systems must be selected.';
    //   return;
    // }

    this.compareGroupService.updateCompareGroup(saveList).subscribe(
      result => {

        this.showAlert = true;
        this.alertIsConfirm = false;
        if (result.success === true) {
          this.alertMessage = 'The Compare Group was saved successfully.';
          this.onReturn(false);
        } else {
          this.alertMessage = 'There was an error when saving the Compare Group: ' + result.message;
        }
      }
    );
  }

  closeAlert() {
    this.showAlert = false;
  }

  onCompareGroupInputFocus() {
    this.noNameGiven = false;
  }

  rowToName(row: string) {
    return this.displayedColumns.filter(dc => dc.def === row).map(dc => dc.label);
  }

  alertConfirm(event) {
    if (event) {
      this.onReturn(false);
    }
  }

  onReturn(needConfirm: boolean = true) {

    if (this.isDirty === false) {
      needConfirm = false;
    }

    if (needConfirm) {
      this.showAlert = true;
      this.alertIsConfirm = true;
      this.alertMessage = 'Are you sure you want to leave this page?\nAll unsaved changes will be lost.';
    } else {
      this.router.navigate([`/comparegroups/${this.organizationId}`]);
    }
  }

  createCompareGroupSaveList(newGroup: boolean): CompareGroupMemberListDTO {

    const members: number[] = [];

    this.compareGroupMemberList.forEach(
      m => {
        members.push(m.memberOrgId);
      }
    );

    let id = this.compareGroupId;
    if (newGroup || this.compareGroupId === undefined) {
      id = 0;
    }

    const list: CompareGroupMemberListDTO = {
      compareGroupDesc: this.compareGroupDescription,
      compareGroupId: id,
      orgId: this.organizationId,
      compareGroupMembers: members
    };

    return list;
  }
}
